import { API_INFO } from 'constants';
import { methodGet } from './methods';

export const getClientsApi = (payload) => {
  const url = API_INFO + `user/clients/`;
  return methodGet(url, payload);
};
